import { render, staticRenderFns } from "./IcoCertificate.vue?vue&type=template&id=e5ec4864"
import script from "./IcoCertificate.vue?vue&type=script&lang=js"
export * from "./IcoCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports